import { getJwtTools } from "@/components/authentication/utils";
import { useEffect, useState } from "react";

/**
 * The portfolio types from the JWT, plus whether that lookup has resolved.
 *
 * An empty `types` reads the same whether the lookup is still pending or the
 * user has none configured, so anything filtering on it waits for `isReady`.
 */
export const useAvailablePortfolioTypesState = () => {
  const [state, setState] = useState<{ types: string[]; isReady: boolean }>({ types: [], isReady: false });

  useEffect(() => {
    getJwtTools()
      .then((tools) => {
        const types = tools?.comprehensive?.portfolioInsights?.availablePortfolioTypes;
        setState({ types: types?.length ? types : [], isReady: true });
      })
      .catch(() => setState({ types: [], isReady: true }));
  }, []);
  return state;
};

export const useAvailablePortfolioTypes = () => useAvailablePortfolioTypesState().types;
